import React, { useEffect } from "react";
import "./styles.css";
// import Select from "react-select";
import { Select } from "antd";

const HeaderDropDown = ({
  options,
  onChange,
  placeholder,
  value,
  defaultValue,
  disabled,
  classNamePrefix = "select",
  getPopupContainer,
  dropdownMatchSelectWidth,
  loading,
  testId,
}) => {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = React.useState(
    isControlled ? value ?? null : defaultValue ?? null
  );

  useEffect(() => {
    if (isControlled) {
      setInternalValue(value ?? null);
    }
  }, [isControlled, value]);

  useEffect(() => {
    if (!isControlled) {
      setInternalValue(defaultValue ?? null);
    }
  }, [defaultValue, isControlled]);

  const handleChange = (newValue) => {
    if (!isControlled) {
      setInternalValue(newValue ?? null);
    }
    if (typeof onChange === "function") {
      onChange(newValue ?? null);
    }
  };

  return (
    <div
      data-testid={testId ? `${testId}-wrapper` : `${classNamePrefix}-dropdown`}
      className={classNamePrefix}
    >
      <Select
        data-testid={testId}
        value={(isControlled ? value : internalValue) ?? undefined}
        className="header-dropdown-select"
        onChange={handleChange}
        options={options}
        disabled={disabled}
        loading={loading}
        getPopupContainer={getPopupContainer || ((trigger) => trigger.parentNode)}
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        placeholder={placeholder}
      />
    </div>
  );
};

export default HeaderDropDown;
